<template>
    <div class="top-container">
        <common-header-wrap type="defaultText" :showSites="false" />
        <div id="app" class="frame-container">
            <router-view></router-view>
        </div>
        <transition name="fade">
            <div class="modal-mask" v-show="mask" style="z-index: 10000" :style="{zIndex: maskZindex}">

            </div>
        </transition>
    </div>
</template>

<script>
    import CommonHeaderWrap from '@/components/common/CommonHeaderWrap.vue';
    export default {
        name: 'login',
        components: {CommonHeaderWrap},
        data () {
            return {};
        },
        computed: {
            mask () {
                return this.$store.state.maskShown.isShow;
            },
            maskZindex () {
                return this.$store.state.maskShown.zIndex;
            }
        },
        mounted () {
            document.title = window.__APP__CONFIG.pt_name;
            // this.fakeAppUrls();
        },
        methods: {
            // fakeAppUrls () {
            //     this.$api(this.$config.apiUrl.appUrls).then(res => {
            //         this.$store.commit('appUrls', res);
            //     }).catch(e => {
            //         this.$alias.error('获取站点url信息失败');
            //     });
            // }
        }
    };
</script>

<style lang="less" scoped>
    @import '../southcn-ui2/src/assets/less/widgets-var';

    #app, .top-container {
        min-width: 1200px;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        position: relative;
    }


    .modal-mask {
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
    }

</style>
